<template>
  <div class="forget">
    <header class="header">
      <p>忘记密码</p>
    </header>
    <main>
      <div class="input-box">
        <input type="text" @input="changeBtn" v-model="username" placeholder="请输入手机号" />
      </div>

      <div class="input-box input-l">
        <input type="text" @input="changeBtn" v-model="imgcode" placeholder="请输入图片验证码" />
        <div class="img-code">
          <img :src="codeUrl" @click="getImgCode" />
        </div>
      </div>

      <div class="input-box">
        <input type="text" v-model="code" placeholder="请输入验证码" @input="changeBtn" />
        <button class="sms-code" @click="getCode">{{ smsText }}</button>
      </div>

      <div class="input-box">
        <input type="password" v-model="password" @input="changePas" placeholder="请输入新密码" />
        <div class="del-calss" @click="delPass" v-if="showPas">
          <svg-icon icon-class="icon_close" style="width: 0.36rem; height: 0.36rem"></svg-icon>
        </div>
      </div>

      <div class="input-box">
        <input type="password" v-model="newpassword" @input="changenewPas" placeholder="请再次输入新密码" />
        <div class="del-calss" @click="delNewPass" v-if="showNewPas">
          <svg-icon icon-class="icon_close" style="width: 0.36rem; height: 0.36rem"></svg-icon>
        </div>
      </div>
    </main>
    <div class="nexbu">
      <button @click="forget" :class="{ active: flag }">完成</button>
    </div>
  </div>
</template>
<script>
import { getCodeImg, sentForgetSmsCode, findpass } from '@/api/login'
export default {
  data() {
    return {
      imgcode: '', //图片验证码
      codeUrl: '', //验证码图片地址
      smsText: '获取验证码',
      smsTime: 60, //获取验证码时间
      username: '', //手机号
      code: '', //短信验证码
      uuid: '',
      flag: false,
      password: '',
      newpassword: '',
      showPas: false,
      showNewPas: false,
    }
  },
  created() {
    this.getImgCode()
  },
  methods: {
    delPass() {
      console.log('eee???')
      this.password = ''
      this.showPas = false
    },
    delNewPass() {
      console.log('hhhhh???')
      this.newpassword = ''
      this.showNewPas = false
    },
    changeBtn() {
      if (this.username && this.imgcode && this.code && this.password && this.newpassword) {
        this.flag = true
      } else {
        this.flag = false
      }
    },
    changePas() {
      this.showPas = true
      if (!this.password) {
        this.showPas = false
      }
      if (this.username && this.imgcode && this.code && this.password && this.newpassword) {
        this.flag = true
      } else {
        this.flag = false
      }
    },
    changenewPas() {
      this.showNewPas = true
      if (!this.newpassword) {
        this.showNewPas = false
      }
      if (this.username && this.imgcode && this.code && this.password && this.newpassword) {
        this.flag = true
      } else {
        this.flag = false
      }
    },
    forget() {
      findpass(this.username, this.code, this.password)
        .then((res) => {
          if (res.code === 200) {
            this.$toast(res.message)
            this.$router.push('/enterpriseSpecialH5/login')
          } else {
            this.$toast(res.message)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getSmsCode() {
      const mobile = this.username
      const type = 'forget'
      const uuid = this.uuid
      const imgCode = this.imgcode
      sentForgetSmsCode(mobile, type, uuid, imgCode).then((res) => {
        if (res.code === 200) {
          const me = this
          me.smsText = me.smsTime + '秒后重发'
          --me.smsTime
          const interval = window.setInterval(function() {
            me.smsText = me.smsTime + '秒后重发'
            --me.smsTime
            if (me.smsTime < 0) {
              me.smsText = '获取验证码'
              me.smsTime = 60
              window.clearInterval(interval)
            }
          }, 1000)
        } else if (res.code === 400) {
          this.getImgCode()
        } else {
          this.$toast(res.message)
        }
      })
    },
    getCode() {
      const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
      if (reg.test(this.username)) {
        this.getSmsCode()
      } else if (this.username == '') {
        this.$toast('请输入正确的手机号')
      } else {
        this.$toast('请输入正确的手机号')
      }
    },
    getImgCode() {
      getCodeImg().then((res) => {
        this.codeUrl = 'data:image/gif;base64,' + res.img
        this.uuid = res.uuid
      })
    },
  },
}
</script>
<style lang="less" scoped>
.forget {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}
.header {
  width: 100%;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    width: 1.92rem;
    height: 0.4rem;
    font-size: 0.48rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(72, 72, 72, 1);
    line-height: 0.4rem;
  }
}
.input-box {
  width: 6.3rem;
  border-bottom: 1px solid rgba(227, 227, 227, 1);
  position: relative;
  input {
    background: none;
    border: none;
    outline: none;
    height: 1rem;
    line-height: 0.5rem;
    font-size: 0.28rem;
    padding: 0;
    margin-bottom: 0;
  }
  .input-l {
    width: 2rem;
    border-bottom: 1px solid rgba(227, 227, 227, 1);
  }
  .img-code {
    width: 2rem;
    height: 1rem;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    right: 0;
    img {
      width: 1.7rem;
      height: 0.7rem;
    }
  }
  .del-calss {
    position: absolute;
    right: 0;
    top: 0.38rem;
    width: 0.28rem;
    height: 0.28rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f5f5;
    border-radius: 50%;
  }
  input::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #c5c5c5;
    font-size: 0.28rem;
  }
  input::-moz-placeholder {
    /* Firefox 19+ */
    color: #c5c5c5;
    font-size: 0.28rem;
  }
  input:-ms-input-placeholder {
    /* IE 10+ */
    color: #c5c5c5;
    font-size: 0.28rem;
  }
  input:-moz-placeholder {
    /* Firefox 18- */
    color: #c5c5c5;
    font-size: 0.28rem;
  }
  .sms-code {
    color: #797979;
    background: rgba(245, 245, 245, 1);
    font-size: 0.28rem;
    width: 1.7rem;
    height: 0.7rem;
    line-height: 0.7rem;
    position: absolute;
    right: 0;
    top: 0.15rem;
    padding: 0;
    border-radius: 0.06rem;
  }
}
.nexbu {
  margin-top: 0.8rem;
  button {
    width: 6.3rem;
    height: 0.9rem;
    border-radius: 0.05rem;
    font-size: 0.32rem;
    background: rgba(17, 142, 233, 0.3);
    color: #ffffff;
  }
  .active {
    width: 6.3rem;
    height: 0.9rem;
    border-radius: 0.05rem;
    font-size: 0.32rem;
    background: rgba(17, 142, 233, 1);
    color: #ffffff;
  }
}
button {
  margin: 0;
  border: 1px solid transparent;
  outline: none;
}
</style>
